import { useState, useEffect } from 'react'
import { Slider, Rail, Handles, Tracks } from 'react-compound-slider'
import { Handle, Track } from './XSliderElements'
import { xRailStyle, XSliderContainer } from './StyledElements'

const XSlider = ({
  timeDomain,
  handleValue,
  handleAddSlider,
  bDisabled,
  handleXSliderValue,
  chart,
}) => {
  const xSliderStyle = {
    // Give the slider some width
    width: chart.current
      ? Math.round(
          chart.current.chart.series[0].data[
            chart.current.chart.series[0].data.length - 1
          ].plotX - chart.current.chart.series[0].data[0].plotX
        ) + 'px'
      : '1000px',
    position: 'relative',
    height: 25,
  }

  const [timeValue, setTimeValue] = useState()

  useEffect(() => {
    setTimeValue(handleValue[0])
  }, [handleValue])

  const onSliderChange = (value) => {
    setTimeValue(value[0])
  }

  const onSliderAdd = () => {
    handleAddSlider(timeValue)
  }

  const onSliderUpdate = (value) => {
    handleXSliderValue(value[0])
  }

  return (
    <>
      <XSliderContainer chart={chart} id="xslider">
        <Slider
          rootStyle={xSliderStyle}
          vertical={false}
          mode={1}
          domain={timeDomain}
          step={1000}
          values={handleValue}
          onChange={onSliderChange}
          onUpdate={onSliderUpdate}
          id="slider"
        >
          <Rail>
            {({ getRailProps }) => (
              <div style={xRailStyle} {...getRailProps()} />
            )}
          </Rail>
          <Handles>
            {({ handles, getHandleProps }) => (
              <div className="move-slider-handles">
                {handles.map((handle) => (
                  <Handle
                    key={handle.id}
                    handle={handle}
                    getHandleProps={getHandleProps}
                  />
                ))}
              </div>
            )}
          </Handles>
          <Tracks left={false} right={false}>
            {({ tracks, getTrackProps }) => (
              <div className="move-slider-tracks">
                {tracks.map(({ id, source, target }) => (
                  <Track
                    key={id}
                    source={source}
                    target={target}
                    getTrackProps={getTrackProps}
                  />
                ))}
              </div>
            )}
          </Tracks>
          {/* <Ticks
          count={10 }
        >
          {({ ticks }) => (
            <div className="move-slider-ticks">
              {ticks.map((tick) => (
                <Tick key={tick.id} tick={tick} count={ticks.length} />
              ))}
            </div>
          )}
        </Ticks> */}
        </Slider>
        <button
          className="button is-info is-small ml-2 mr-2"
          onClick={onSliderAdd}
          disabled={bDisabled}
          title="Ajouter un slider de sélection de points"
        >
          +
        </button>
      </XSliderContainer>
    </>
  )
}

export default XSlider
